/**
 * Created by emanuele on 04/02/2017.
 */
import React, {Component} from 'react'
import { Button, Modal, Icon} from 'semantic-ui-react'
import PropTypes from 'prop-types';
import LocalDayWithDayOfWeek from "../LocalDayWithDayOfWeek";
import AttivitaUtenteDelGiorno from '../attivita/AttivitaUtenteDelGiorno';

class ModalAttivitaGiornoUtente extends Component {
    constructor(props) {
        super(props);
        this.state = {isOpen:false};
        this.onClickOk = this.onClickOk.bind(this);
    }

    onClickOk(){
        this.setState({ isOpen: false })
        if (this.props.onClickOk !== undefined){
            this.props.onClickOk();
        }
    }

    handleOpen = () => {
        this.setState({ isOpen: true })
    }

    handleClose = () => {
        this.setState({ isOpen: false })
    }

    render(){
        return <Modal
            centered={false}
            trigger={this.props.children}
            open={this.state.isOpen}
            onClose={this.handleClose}
            onOpen={this.handleOpen}
            size={"mini"}
            closeIcon
        >
            <Modal.Header>Elenco attività di {this.props.utente.nome} di <LocalDayWithDayOfWeek data={this.props.giorno} />
            </Modal.Header>
            <Modal.Content>
                <AttivitaUtenteDelGiorno
                    giorno={this.props.giorno}
                    idUtente={this.props.utente.idUtente}
                />
            </Modal.Content>
            <Modal.Actions>
                <Button primary centered onClick={this.onClickOk} inverted>
                    <Icon name='checkmark' />Chiudi
                </Button>
            </Modal.Actions>
        </Modal>
    }

}
ModalAttivitaGiornoUtente.PropTypes = {
    giorno: PropTypes.string.isRequired,
    utente: PropTypes.object.isRequired,
    onClickOk: PropTypes.func
}

ModalAttivitaGiornoUtente.defaultProps = {
};

export default ModalAttivitaGiornoUtente


/** WEBPACK FOOTER **
 ** ./src/components/report/ModalAttivitaGiornoUtente.js
 **/